module.exports = __webpack_public_path__ + "5b05da2b318b854e927d5e9e4216efec.png";